import React, { useState } from 'react';
import { Box, Container, Typography, Button, Paper, Divider } from '@mui/material';
import PortalLayout from '../components/PortalLayout';
import DataManagementModal from '../components/DataManagementModal';
import DeletionStatusModal from '../components/DeletionStatusModal';
import SecurityIcon from '@mui/icons-material/Security';
import GetAppIcon from '@mui/icons-material/GetApp';
import DeleteIcon from '@mui/icons-material/Delete';

const AccountSettingsPage: React.FC = () => {
  const [openDataManagement, setOpenDataManagement] = useState(false);
  const [openDeletionStatus, setOpenDeletionStatus] = useState(false);

  const handleDeletionRequested = () => {
    setOpenDataManagement(false);
    setTimeout(() => setOpenDeletionStatus(true), 500);
  };

  return (
    <PortalLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 4 }}>
          Kontoeinstellungen
        </Typography>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <SecurityIcon sx={{ fontSize: 32, color: 'primary.main' }} />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Datenschutz & DSGVO-Rechte
            </Typography>
          </Box>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Verwalten Sie Ihre persönlichen Daten nach DSGVO-Richtlinien.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                backgroundColor: 'background.default',
                borderRadius: 1,
              }}
            >
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Meine Daten exportieren
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Laden Sie Ihre Daten als JSON oder CSV herunter
                </Typography>
              </Box>
              <Button
                variant="contained"
                startIcon={<GetAppIcon />}
                onClick={() => setOpenDataManagement(true)}
              >
                Exportieren
              </Button>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                backgroundColor: 'background.default',
                borderRadius: 1,
              }}
            >
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Löschungsstatus
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Überprüfen Sie den Status Ihrer Löschungsanfrage
                </Typography>
              </Box>
              <Button
                variant="outlined"
                onClick={() => setOpenDeletionStatus(true)}
              >
                Status prüfen
              </Button>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                backgroundColor: 'background.default',
                borderRadius: 1,
              }}
            >
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Mein Konto löschen
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Beantragen Sie die Löschung Ihrer Daten (30-Tage Grace-Period)
                </Typography>
              </Box>
              <Button
                variant="contained"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={() => setOpenDataManagement(true)}
              >
                Löschen
              </Button>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="textSecondary">
            Bei Fragen zu Ihren Datenschutzrechten lesen Sie bitte unsere{' '}
            <Box
              component="a"
              href="/privacy"
              sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              Datenschutzerklärung
            </Box>
            .
          </Typography>
        </Paper>
      </Container>

      <DataManagementModal
        open={openDataManagement}
        onClose={() => setOpenDataManagement(false)}
        onDeletionRequested={handleDeletionRequested}
      />

      <DeletionStatusModal
        open={openDeletionStatus}
        onClose={() => setOpenDeletionStatus(false)}
      />
    </PortalLayout>
  );
};

export default AccountSettingsPage;
